import archerDestinationDefault from './assets/archer_destination_default.svg';
import archerDestinationHover from './assets/archer_destination_hover.svg';
import archerDestinationActive from './assets/archer_destination_selected.svg';
import archerDroneDefault from './assets/archer_drone_default.svg';
import archerDroneHover from './assets/archer_drone_hover.svg';
import archerDroneActive from './assets/archer_drone_selected.svg';
import aviveAEDIconAcceptedActive from './assets/avive_aed_accepted_active.svg';
import aviveAEDIconAcceptedDefault from './assets/avive_aed_accepted_default.svg';
import aviveAEDIconAcceptedHover from './assets/avive_aed_accepted_hover.svg';
import aviveAEDIconUnacceptedActive from './assets/avive_aed_unaccepted_active.svg';
import aviveAEDIconUnacceptedDefault from './assets/avive_aed_unaccepted_default.svg';
import aviveAEDIconUnacceptedHover from './assets/avive_aed_unaccepted_hover.svg';
import aviveUserIconAcceptedActive from './assets/avive_appuser_accepted_active.svg';
import aviveUserIconAcceptedDefault from './assets/avive_appuser_accepted_default.svg';
import aviveUserIconAcceptedHover from './assets/avive_appuser_accepted_hover.svg';
import responderIAROtherDefault from './assets/iar_responder_other.svg';
import responderIAROtherHover from './assets/iar_responder_other_hover.svg';
import responderIAROtherActive from './assets/iar_responder_other_selected.svg';
import vehicleIAREMSDefault from './assets/iar_vehicle_ems.svg';
import vehicleIAREMSHover from './assets/iar_vehicle_ems_hover.svg';
import vehicleIAREMSActive from './assets/iar_vehicle_ems_selected.svg';
import vehicleIARFireDefault from './assets/iar_vehicle_fire.svg';
import vehicleIARFireHover from './assets/iar_vehicle_fire_hover.svg';
import vehicleIARFireActive from './assets/iar_vehicle_fire_selected.svg';
import vehicleIAROtherDefault from './assets/iar_vehicle_other.svg';
import vehicleIAROtherHover from './assets/iar_vehicle_other_hover.svg';
import vehicleIAROtherActive from './assets/iar_vehicle_other_selected.svg';
import vehicleIARPoliceDefault from './assets/iar_vehicle_police.svg';
import vehicleIARPoliceHover from './assets/iar_vehicle_police_hover.svg';
import vehicleIARPoliceActive from './assets/iar_vehicle_police_selected.svg';
import publicSonarCrowdControlDefault from './assets/publicsonar_crowdcontrol_default.svg';
import publicSonarCrowdControlHover from './assets/publicsonar_crowdcontrol_hover.svg';
import publicSonarCrowdControlActive from './assets/publicsonar_crowdcontrol_selected.svg';
import publicSonarInfrastructureDefault from './assets/publicsonar_infrastructure_default.svg';
import publicSonarInfrastructureHover from './assets/publicsonar_infrastructure_hover.svg';
import publicSonarInfrastructureActive from './assets/publicsonar_infrastructure_selected.svg';
import publicSonarMobilityDefault from './assets/publicsonar_mobility_default.svg';
import publicSonarMobilityHover from './assets/publicsonar_mobility_hover.svg';
import publicSonarMobilityActive from './assets/publicsonar_mobility_selected.svg';
import publicSonarNaturalDisasterDefault from './assets/publicsonar_naturaldisaster_default.svg';
import publicSonarNaturalDisasterHover from './assets/publicsonar_naturaldisaster_hover.svg';
import publicSonarNaturalDisasterActive from './assets/publicsonar_naturaldisaster_selected.svg';
import publicSonarPublicSafetyDefault from './assets/publicsonar_publicsafety_default.svg';
import publicSonarPublicSafetyHover from './assets/publicsonar_publicsafety_hover.svg';
import publicSonarPublicSafetyActive from './assets/publicsonar_publicsafety_selected.svg';
import rollkallDefault from './assets/rollkall_default.svg';
import rollkallHover from './assets/rollkall_hover.svg';
import rollkallActive from './assets/rollkall_selected.svg';
import slMarkerPoliceDefault from './assets/sl_marker_police_default.svg';
import slMarkerPoliceHover from './assets/sl_marker_police_hover.svg';
import slMarkerPoliceActive from './assets/sl_marker_police_selected.svg';
import towTruckDefault from './assets/tow_truck_default.svg';
import towTruckHover from './assets/tow_truck_hover.svg';
import towTruckActive from './assets/tow_truck_selected.svg';

export const AVIVE = {
  AppUser: 'avive_app',
  Device: 'avive_aed',
};

export const PUBLIC_SONAR = {
  CrowdControl: 'public_sonar_crowd_control',
  VitalInfrastructure: 'public_sonar_vital_infrastructure',
  Mobility: 'public_sonar_mobility',
  NaturalDisaster: 'public_sonar_natural_disaster',
  PublicSafety: 'public_sonar_public_safety',
};

export const IAR = {
  Responder: 'iar_responders',
  Vehicle: 'iar_vehicles',
};
export const ARCHER = {
  Drone: 'archer_drone',
  Destination: 'archer_drop',
};
export const ROLLKALL = 'rollkall';

export const AUTORETURN = 'autoreturn';

export const isPublicSonarLayer = layerKey => {
  return !!Object.values(PUBLIC_SONAR).find(k => k === layerKey);
};

const markers = {
  default: {
    default: slMarkerPoliceDefault,
    hover: slMarkerPoliceHover,
    active: slMarkerPoliceActive,
  },
  [AVIVE.AppUser]: {
    active: aviveUserIconAcceptedActive,
    default: aviveUserIconAcceptedDefault,
    hover: aviveUserIconAcceptedHover,
  },
  [AVIVE.Device]: {
    accepted: {
      default: aviveAEDIconAcceptedDefault,
      hover: aviveAEDIconAcceptedHover,
      active: aviveAEDIconAcceptedActive,
    },
    unaccepted: {
      default: aviveAEDIconUnacceptedDefault,
      hover: aviveAEDIconUnacceptedHover,
      active: aviveAEDIconUnacceptedActive,
    },
  },
  [PUBLIC_SONAR.CrowdControl]: {
    default: publicSonarCrowdControlDefault,
    hover: publicSonarCrowdControlHover,
    active: publicSonarCrowdControlActive,
  },
  [PUBLIC_SONAR.VitalInfrastructure]: {
    default: publicSonarInfrastructureDefault,
    hover: publicSonarInfrastructureHover,
    active: publicSonarInfrastructureActive,
  },
  [PUBLIC_SONAR.Mobility]: {
    default: publicSonarMobilityDefault,
    hover: publicSonarMobilityHover,
    active: publicSonarMobilityActive,
  },
  [PUBLIC_SONAR.NaturalDisaster]: {
    default: publicSonarNaturalDisasterDefault,
    hover: publicSonarNaturalDisasterHover,
    active: publicSonarNaturalDisasterActive,
  },
  [PUBLIC_SONAR.PublicSafety]: {
    default: publicSonarPublicSafetyDefault,
    hover: publicSonarPublicSafetyHover,
    active: publicSonarPublicSafetyActive,
  },
  [ROLLKALL]: {
    default: rollkallDefault,
    hover: rollkallHover,
    active: rollkallActive,
  },

  [IAR.Responder]: {
    default: responderIAROtherDefault,
    hover: responderIAROtherHover,
    active: responderIAROtherActive,
  },
  [IAR.Vehicle]: {
    other: {
      default: vehicleIAROtherDefault,
      hover: vehicleIAROtherHover,
      active: vehicleIAROtherActive,
    },
    police: {
      default: vehicleIARPoliceDefault,
      hover: vehicleIARPoliceHover,
      active: vehicleIARPoliceActive,
    },
    fire: {
      default: vehicleIARFireDefault,
      hover: vehicleIARFireHover,
      active: vehicleIARFireActive,
    },
    ems: {
      default: vehicleIAREMSDefault,
      hover: vehicleIAREMSHover,
      active: vehicleIAREMSActive,
    },
  },
  [ARCHER.Drone]: {
    active: archerDroneActive,
    default: archerDroneDefault,
    hover: archerDroneHover,
  },
  [ARCHER.Destination]: {
    active: archerDestinationActive,
    default: archerDestinationDefault,
    hover: archerDestinationHover,
  },
  [AUTORETURN]: {
    default: towTruckDefault,
    hover: towTruckHover,
    active: towTruckActive,
  },
};

/**
 * Checks if the given `layerKey` contains the `targetLayerKey`.
 *
 * This is a failsafe to improve resilience of the app whenever naming
 * conventions are not followed during onboarding. This saves us from delaying
 * customer use in order to implement an exact match for specific string casing.
 *
 * @param {string} layerKey - The layer key that's being checked
 * @param {string} targetLayerKey - the value that layerKey should contain
 */
const includesLayerKey = (layerKey, targetLayerKey) => {
  if (!layerKey) {
    return false;
  }
  const result = `${layerKey}`
    .toLowerCase()
    .includes(`${targetLayerKey}`.toLowerCase());

  return result;
};

const selectMarkerIcon = (
  layerData = {},
  markerType = 'default',
  objectData = {},
) => {
  let layerDataKey = layerData?.key || '';

  if (includesLayerKey(layerDataKey, ROLLKALL)) {
    layerDataKey = ROLLKALL;
  } else if (includesLayerKey(layerDataKey, AUTORETURN)) {
    layerDataKey = AUTORETURN;
  }

  if (markers[layerDataKey]) {
    let markerSet = markers[layerDataKey];
    if (layerDataKey === IAR.Vehicle) {
      const apparatusType =
        objectData.attributes.vehicle_details.ApparatusTypeName;
      markerSet =
        markerSet?.[`${apparatusType}`.toLowerCase()] || markerSet.other;
    }

    // It's avive if accepted/unaccepted icons are available.
    if (markerSet.accepted || markerSet.unaccepted) {
      const resourceAccepted = objectData?.attributes?.resource_accepted || '';
      const isAccepted = `${resourceAccepted}`.toLowerCase() === 'true';
      if (isAccepted) {
        return markerSet.accepted[markerType];
      }
      return markerSet.unaccepted[markerType];
    }

    return markerSet[markerType];
  }
  return markers.default[markerType];
};

export default selectMarkerIcon;
